module.exports = "/_next/static/images/Processing-eefeea2a2a7f22cf689752e32f645b80.webp";